const cities = [
  { name: "Plymouth", zips: "55441, 55442, 55446, 55447" },
  { name: "Wayzata", zips: "55391" },
  { name: "Medina", zips: "55340, 55356, 55357" },
  { name: "Maple Grove", zips: "55311, 55369" },
  { name: "Minnetonka", zips: "55305, 55343, 55345" },
  { name: "Minneapolis", zips: "55401–55419" },
];

const benefits = [
  { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from your Plymouth home or office in minutes." },
  { icon: "ri-truck-line", title: "Ship Your Documents", desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there." },
  { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays." },
  { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed." },
];

export default function PlymouthMNLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white pt-12 md:pt-14 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Plymouth &amp; Western Hennepin County
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Plymouth, Minnesota is consistently ranked among the best places to live in the United States, and its residents maintain active international lifestyles. Located in western Hennepin County with easy access to I-494 and Highway 55, Plymouth is a bedroom community for Minneapolis corporate headquarters, medical professionals, and technology workers. The city's high median income and educated population translate to frequent international travel — business trips to Europe and Asia, family vacations to the Caribbean, and medical conferences worldwide.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The corporate commuter pattern is significant. Plymouth residents work at companies with global operations — Medtronic, 3M, UnitedHealth Group, and Target, among others. These employees often receive international travel assignments with short notice: a sales meeting in Tokyo, a training session in London, a client audit in São Paulo. When an executive discovers their passport expired during the pandemic-era travel slowdown, they need a solution that works on a business timeline, not a government one.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Plymouth families — many with children in the highly rated Wayzata and Robbinsdale school districts — plan spring break trips, summer European tours, and holiday cruises that depend on current passports for every family member. Medical professionals from the nearby healthcare systems also travel internationally for conferences, continuing education, and medical mission work. Fast Passport Center provides the expedited, professional service that Plymouth's active traveler community demands.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Plymouth, MN</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of Hennepin County remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — serving Plymouth, Wayzata, Maple Grove, Minnetonka, Medina &amp; Minneapolis
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Ship your documents overnight from anywhere in the western metro</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, ship your documents with our <strong className="text-white">prepaid overnight label</strong> from any UPS or FedEx location in the Plymouth area. Most clients never need to visit an office — just start online, ship overnight, and we handle the rest.
                </p>
                <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap">
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && <span className="text-gray-400 text-xs font-mono hidden sm:inline truncate ml-2 max-w-[160px]">{city.zips}</span>}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">Anywhere in Hennepin County and the western metro — start online, ship overnight, and we handle the rest.</p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Minneapolis", href: "/cities/minneapolis" },
                    { name: "Maple Grove", href: "/cities/maple-grove" },
                    { name: "Minnetonka", href: "/cities/minnetonka" },
                    { name: "Eden Prairie", href: "/cities/eden-prairie" },
                    { name: "Edina", href: "/cities/edina" },
                    { name: "St. Paul", href: "/cities/st-paul" },
                  ].map((link) => (
                    <a key={link.href + link.name} href={link.href} className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap">
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Plymouth Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a key={i} href="https://fastpassportcenter.com" className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}